<script>
  export let opened = false;
  export let onClick;
  export let theme;
  import { onMount } from "svelte";
  import * as PropTypes from "prop-types";
  const { bool, func, string, checkPropTypes } = PropTypes;

  const propTypes = {
    // if menu is opened or not
    opened: bool,
    // function when menu is opened
    onClick: func,
    theme: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "MenuButton");
  });

  const hasForcedTheme = theme !== undefined;
  const bgc = hasForcedTheme
    ? `${theme === "dark" ? "bg-white" : "bg-black"}`
    : `bg-black dark:bg-white`;
  const accordianClass = `${bgc} h-3xs rounded-[1px] trs-accordian`;
</script>

<div
  class="w-lxg cursor-pointer"
  role="button"
  aria-label="Main Menu"
  on:click={onClick}
  data-testid="menu-button"
>
  <div
    class={`${accordianClass} ${opened ? "tranlate-y-[9px] rotate-45" : ""}`}
  />
  <div
    class={`${accordianClass} my-[7px] ${opened ? "opacity-0" : "opacity-100"}`}
  />
  <div class={`${accordianClass} ${opened ? "Trf($trfmenuIconBottom)" : ""}`} />
</div>
